import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import backgroundImage from '../assets/images/stage2-game/bg.png'
import leftBtn from '../assets/images/stage2-game/left.png'
import rightBtn from '../assets/images/stage2-game/right.png'
import pullCab from '../assets/images/stage2-game/pull-cab.png'
import putCab from '../assets/images/stage2-game/put-cab.png'
import cabBlue from '../assets/images/stage2-game/cab-blue.png'
import cabRed from '../assets/images/stage2-game/cab-red.png'
import cabYellow from '../assets/images/stage2-game/cab-yellow.png'
import clip from '../assets/images/stage2-game/clip.png'
import line from '../assets/images/stage2-game/line.png'
import remove25 from '../assets/images/stage2-game/remove-25.png'
import add50 from '../assets/images/stage2-game/add-50.png'

const clipLeftMin = 5
const clipLeftMax = 90
const FADE_OUT_SPACING = 0.35;
const OPACITY_INTERVAL = 300;

function createRandomNumber(min, max) {
    return Math.random() * (max - min) + min;
}

const cabs = [ cabRed, cabBlue, cabYellow ];
const lineMinHeight = 10;
const lineMaxHeight = 69;
const putCabHeight = 50;
const fixedTop = 19.5;
const fixedCabWidth = 12.5;
const clipWidth = 5.4;

class Stage2Game extends Component {

    btnSound = './sounds/button_sound.mp3';

    pullDownInterval = null;
    pullUpInterval = null;
    animationTick = 100;
    movingTick = 2;
    countdownInterval = null;
    redCabAdd50Interval = null;
    blueCabAdd50Interval = null;
    yellowCabAdd50Interval = null;
    remove25Interval = null;
    playing = false;
    moveInterval = null;

    constructor(props) {
        super(props);
        this.state = {
            score: 0,
            countdown: 60,
            clipLeft: 30,
            objects: this.createRenderObject(),
            lineHeight: lineMinHeight,
            target: null,
            grabCabImage: null,
            redCabOnCarEnable: false,
            blueCabOnCarEnable: false,
            yelloCabOnCarEnable: false,
            successCount: 0,
            failCount: 0,
            add50RedOpacity: 0.0,
            add50BlueOpacity: 0.0,
            add50YellowOpacity: 0.0,
            remove25Opacity: 0.0
        }
    }

    componentDidMount() {
        this.playing = true;
        this.countdownInterval = setInterval(() => {
            if (this.state.countdown === 0) {
                this.gameOver();
            } else {
                this.setState({
                    countdown: this.state.countdown - 1
                });
            }
        }, 1 * 1000);
    }

    componentWillUnmount() {
        clearInterval(this.countdownInterval);  
        clearInterval(this.blueCabAdd50Interval);
        clearInterval(this.redCabAdd50Interval);
        clearInterval(this.yellowCabAdd50Interval);
        clearInterval(this.remove25Interval);
        clearInterval(this.moveInterval);
    }

    redCabAdd50() {
        if (this.redCabAdd50Interval !== null) {
            clearInterval(this.redCabAdd50Interval);
        }
        this.setState({
            add50RedOpacity: 1.0
        });
        this.redCabAdd50Interval = setInterval(() => {
            if (this.state.add50RedOpacity >= 0) {
                this.setState({
                    add50RedOpacity: this.state.add50RedOpacity - FADE_OUT_SPACING
                })
            } else {
                clearInterval(this.redCabAdd50Interval)
            }
        }, OPACITY_INTERVAL);
    }

    blueCabAdd50() {
        if (this.blueCabAdd50Interval !== null) {
            clearInterval(this.blueCabAdd50Interval);
        }
        this.setState({
            add50BlueOpacity: 1.0
        });
        this.blueCabAdd50Interval = setInterval(() => {
            if (this.state.add50BlueOpacity >= 0) {
                this.setState({
                    add50BlueOpacity: this.state.add50BlueOpacity - FADE_OUT_SPACING
                })
            } else {
                clearInterval(this.blueCabAdd50Interval)
            }
        }, OPACITY_INTERVAL);
    }

    yellowCabAdd50() {
        if (this.yellowCabAdd50Interval !== null) {
            clearInterval(this.yellowCabAdd50Interval);
        }
        this.setState({
            add50YellowOpacity: 1.0
        });
        this.yellowCabAdd50Interval = setInterval(() => {
            if (this.state.add50YellowOpacity >= 0) {
                this.setState({
                    add50YellowOpacity: this.state.add50YellowOpacity - FADE_OUT_SPACING
                })
            } else {
                clearInterval(this.yellowCabAdd50Interval)
            }
        }, OPACITY_INTERVAL);
    }

    remove25() {
        if (this.remove25Interval !== null) {
            clearInterval(this.remove25Interval);
        }
        this.setState({
            remove25Opacity: 1.0
        });
        this.remove25Interval = setInterval(() => {
            if (this.state.remove25Opacity >= 0) {
                this.setState({
                    remove25Opacity: this.state.remove25Opacity - FADE_OUT_SPACING
                })
            } else {
                clearInterval(this.remove25Interval)
            }
        }, OPACITY_INTERVAL);
    }
    
    gameOver() {
        this.props.history.push({
            pathname: './stage2-result',
            state: {
                successCount: this.state.successCount,
                failCount: this.state.failCount,
                game2Score: this.state.score,
                distance: this.props.location.state.distance,
                game1Score: this.props.location.state.score
            }
        });
    };

    findTarget() {
        let boundryLeft = this.state.clipLeft;
        let boundryRight = boundryLeft + clipWidth;
        let newObjects = this.state.objects;
        let targetIndexArray = [];
        for (let i = 0; i < newObjects.length; i++) {
            let obj = newObjects[i];
            if (obj.left <= boundryLeft && obj.left + fixedCabWidth >= boundryRight) {
                targetIndexArray.push(i);
            }
        }
        if (targetIndexArray.length > 0) {
            let minTop = 100;
            let targetIndex = 0;
            for (let i = 0; i < targetIndexArray.length; i++) {
                if (minTop > newObjects[targetIndexArray[i]].top) {
                    minTop = newObjects[targetIndexArray[i]].top;
                    targetIndex = targetIndexArray[i];
                }
            }
            this.setState({
                objects: newObjects,
                target: newObjects[targetIndex],
            });
            //22, 37, 53, 69
            if (newObjects[targetIndex].top === 48) {
                return 22;
            } else if (newObjects[targetIndex].top === 56) {
                return 37;
            } else if (newObjects[targetIndex].top === 64) {
                return 53;
            } else if (newObjects[targetIndex].top === 72) {
                return 69;
            }
        }
        return 22;
    }

    pullDown() {
        if (this.pullDownInterval !== null) {
            clearInterval(this.pullDownInterval);
            this.pullDownInterval = null;
        }
        if (this.pullUpInterval !== null) {
            clearInterval(this.pullUpInterval);
            this.pullUpInterval = null;
        }
        if (this.state.target === null) {
            let target = this.findTarget();
            this.pullDownInterval = setInterval(() => {
                if (this.state.lineHeight < target) {
                    this.setState({
                        lineHeight: this.state.lineHeight + this.movingTick
                    })
                } else {
                    if (this.state.target !== null) {
                        let newObjects = this.state.objects;
                        let targetIndex = newObjects.indexOf(this.state.target);
                        newObjects[targetIndex].target = true;
                        this.setState({
                            grabCabImage: cabs[this.state.target.colorIndex],
                            objects: newObjects,
                            target: newObjects[targetIndex]
                        });
                    }
                    clearInterval(this.pullDownInterval);
                }
            }, this.animationTick);
        } else {
            this.pullDownInterval = setInterval(() => {
                if (this.state.lineHeight < putCabHeight) {
                    this.setState({
                        lineHeight: this.state.lineHeight + this.movingTick
                    })
                } else {
                    clearInterval(this.pullDownInterval);
                    let success = this.judgeCabPosition();
                    let newObjects = this.state.objects;
                    let targetIndex = newObjects.indexOf(this.state.target);
                    let colorIndex = this.state.target.colorIndex;
                    if (success) {
                        newObjects.splice(targetIndex, 1);
                        this.setState({
                            objects: newObjects,
                            target: null,
                            grabCabImage: null,
                            redCabOnCarEnable: colorIndex === 0 ? true : this.state.redCabOnCarEnable,
                            blueCabOnCarEnable: colorIndex === 1 ? true : this.state.blueCabOnCarEnable,
                            yellowCabOnCarEnable: colorIndex === 2 ? true : this.state.yellowCabOnCarEnable,
                            successCount: this.state.successCount + 1,
                            score: this.state.score + 50
                        });
                        if (colorIndex === 0) {
                            this.redCabAdd50();
                        } else if (colorIndex === 1) {
                            this.blueCabAdd50();
                        } else if (colorIndex === 2) {
                            this.yellowCabAdd50();
                        }
                    } else {
                        newObjects[targetIndex].target = false;
                        this.setState({
                            objects: newObjects,
                            target: null,
                            grabCabImage: null,
                            failCount: this.state.successCount + 1,
                            score: this.state.score - 25 < 0 ? this.state.score : this.state.score - 25
                        });
                        this.remove25();
                    }
                }
            }, this.animationTick);
        }
    }

    pullUp() {
        if (this.pullDownInterval !== null) {
            clearInterval(this.pullDownInterval);
            this.pullDownInterval = null;
        }
        if (this.pullUpInterval !== null) {
            clearInterval(this.pullUpInterval);
            this.pullUpInterval = null;
        }
        if (this.state.target !== null) {
            this.pullUpInterval = setInterval(() => {
                if (this.state.lineHeight > lineMinHeight) {
                    this.setState({
                        lineHeight: this.state.lineHeight - this.movingTick
                    })
                } else {
                    clearInterval(this.pullUpInterval);
                }
            }, this.animationTick);
        } else {
            this.pullUpInterval = setInterval(() => {
                if (this.state.lineHeight > lineMinHeight) {
                    this.setState({
                        lineHeight: this.state.lineHeight - this.movingTick
                    })
                } else {
                    clearInterval(this.pullUpInterval);
                }
            }, this.animationTick);
        }
    }

    judgeCabPosition() {
        let success = false;
        let target = this.state.target;
        let colorIndex = target.colorIndex;
        let left = this.state.clipLeft;
        if (colorIndex === 0) {
            if (left >= 38 && left <= 47) {
                success = true;
            }
        } else if (colorIndex === 1) {
            if (left >= 58 && left <= 67) {
                success = true;
            }
        } else if (colorIndex === 2) {
            if (left >= 78 && left <= 87) {
                success = true;
            }
        }
        return success;
    }

    createRenderObject() {
        let obj = [];
        let topPosition = [ 48, 56, 64, 72 ];
        let colorIndex = 0
        for (let i = 0; i < 3; i++) {
            for (let j = 0; j < topPosition.length; j++) {
                let randLeft = createRandomNumber(i * 13, (i * 13) + 2);
                obj.push({
                    left: randLeft,
                    top: topPosition[j],
                    colorIndex: colorIndex,
                    target: false
                });
                colorIndex = colorIndex + 1 >= cabs.length ? 0 : colorIndex + 1;
            }
        }
        return obj;
    }

    playBtnSound() {
        let btnAudio = new Audio(this.btnSound);
        btnAudio.play();
    }

    clipMoveLeft() {
        if (this.moveInterval !== null) {
            clearInterval(this.moveInterval);
        }
        this.setState({
            clipLeft: this.state.clipLeft - 1 < clipLeftMin ? this.state.clipLeft : this.state.clipLeft - 1
        });
        this.moveInterval = setInterval(() => {
            this.setState({
                clipLeft: this.state.clipLeft - 1 < clipLeftMin ? this.state.clipLeft : this.state.clipLeft - 1
            });
        }, 100);
    }

    cancelClipMoveLeft() {
        if (this.moveInterval !== null) {
            clearInterval(this.moveInterval);
        }
    }

    clipMoveRight() {
        if (this.moveInterval !== null) {
            clearInterval(this.moveInterval);
        }
        this.setState({
            clipLeft: this.state.clipLeft + 1 > clipLeftMax ? this.state.clipLeft : this.state.clipLeft + 1
        });
        this.moveInterval = setInterval(() => {
            this.setState({
                clipLeft: this.state.clipLeft + 1 > clipLeftMax ? this.state.clipLeft : this.state.clipLeft + 1
            });
        }, 100);
    }

    cancelClipMoveRight() {
        if (this.moveInterval !== null) {
            clearInterval(this.moveInterval);
        }
    }

    objectRender(key) {
        let item = this.state.objects[key];
        let left = item.left + '%'
        let top = item.top + '%'
        let uniqKey = 'cab-' + key;
        let opacity = item.target ? '0.0' : '1.0';
        return (<img alt='' key={uniqKey} src={cabs[item.colorIndex]} style={{ position: 'absolute', width: `${ fixedCabWidth }%`, left: left, top: top, opacity: `${ opacity }` }}></img>);
    }

    render() {
        return (
            <div className='page-root-div'>
                <img alt='' src={backgroundImage} style={{ width: '100%', height: '100%', overflow: 'hidden', objectFit: 'cover', position: 'absolute' }}/>
                <div style={{ position: 'absolute', right: '5%', top: '3.9%', width: '7.5%', height: '7%', color: '#086940' }}>
                    <svg width='100%' height='100%' viewBox='0 0 500 75' preserveAspectRatio="xMinYMid meet" style={{ position: 'absolute' }} xmlns="http://www.w3.org/2000/svg" xmlnsXlink='http://www.w3.org/1999/xlink'>
                        <text x="50%" y ="50%" dominantBaseline="middle" textAnchor="middle" fontSize="200" fill="#152b85" >{this.state.score}</text>
                    </svg>
                </div>
                <div style={{ position: 'absolute', left: '13.5%', top: '1.4%', width: '4.5%', height: '8%', color: '#086940' }}>
                    <svg width='100%' height='100%' viewBox='0 0 500 75' preserveAspectRatio="xMinYMid meet" style={{ position: 'absolute' }} xmlns="http://www.w3.org/2000/svg" xmlnsXlink='http://www.w3.org/1999/xlink'>
                        <text x="50%" y ="50%" dominantBaseline="middle" textAnchor="middle" fontSize="300" fill="#ffffff" >{this.state.countdown}</text>
                    </svg>
                </div>
                {
                    this.state.redCabOnCarEnable && <img alt='' src={cabs[0]} style={{ position: 'absolute', width: `${ fixedCabWidth }%`, left: '41%', bottom: '28%' }}></img>
                }
                {
                    this.state.blueCabOnCarEnable && <img alt='' src={cabs[1]} style={{ position: 'absolute', width: `${ fixedCabWidth }%`, left: '61%', bottom: '28%' }}></img>
                }
                {
                    this.state.yellowCabOnCarEnable && <img alt='' src={cabs[2]} style={{ position: 'absolute', width: `${ fixedCabWidth }%`, left: '81%', bottom: '28%' }}></img>
                }
                
                {Object.keys(this.state.objects).map(key => this.objectRender(key))}
                <div style={{ width: `${ clipWidth }%`, height: '52%', left: `${ this.state.clipLeft }%`, top: `${ fixedTop }%`, position: 'absolute' }}>
                    <img alt='' src={line} style={{ width: '26%', height: `${ this.state.lineHeight }%`, marginLeft: '36.5%', marginTop: '0%', marginBottom: '-20%' }}/>
                    <img alt='' src={clip} style={{ width: '100%' }}/>
                    <img alt='' src={this.state.grabCabImage} style={{ width: '232%', marginTop: '-15%', marginLeft: '-69%' }}></img>
                </div>
                <img alt='' src={add50} style={{ position: 'absolute', width: '12.23%', top: '44%', right: '46%', opacity: this.state.add50RedOpacity }}></img>
                <img alt='' src={add50} style={{ position: 'absolute', width: '12.23%', top: '44%', right: '26%', opacity: this.state.add50BlueOpacity }}></img>
                <img alt='' src={add50} style={{ position: 'absolute', width: '12.23%', top: '44%', right: '6%', opacity: this.state.add50YellowOpacity }}></img>
                <img alt='' src={remove25} style={{ position: 'absolute', width: '12.23%', top: '10%', left: '47%', opacity: this.state.remove25Opacity }}></img>
                {/* {
                    this.state.target !== null && <img alt='' src={cabs[this.state.target.colorIndex]} style={{ position: 'absolute', width: `${ fixedCabWidth }%`, left: `${ this.state.target.left }%`, top: `${ this.state.target.top }%` }}></img>
                } */}
                <img className='press-btn' alt='' src={leftBtn} style={{ width: '3.9%', right: '19.4%', bottom: '7.5%', position: 'absolute' }} onMouseDown={this.clipMoveLeft.bind(this)} onMouseUp={this.cancelClipMoveLeft.bind(this)}/>
                <img className='press-btn' alt='' src={rightBtn} style={{ width: '3.9%', right: '13.7%', bottom: '7.5%', position: 'absolute' }} onMouseDown={this.clipMoveRight.bind(this)} onMouseUp={this.cancelClipMoveRight.bind(this)}/>
                <img className='press-btn' alt='' src={pullCab} style={{ width: '7.18%', right: '5%', bottom: '12%', position: 'absolute' }} onClick={this.pullUp.bind(this)}/>
                <img className='press-btn' alt='' src={putCab} style={{ width: '7.23%', right: '4%', bottom: '5.8%', position: 'absolute' }} onClick={this.pullDown.bind(this)}/>
            </div>
        )
    }
}

export default withRouter(Stage2Game);
